<div class="container-fluid admin-page messages-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Messages' | translate }}</h1>
            <p>{{ 'Send push notifications to drivers using the Android app.' | translate }}</p>
        </div>
    </header>

    <div class="messages-grid">
        @if (canBroadcastDriverMessage) {
            <section class="message-panel">
        <div class="message-panel-heading">
            <i class="material-icons">campaign</i>
            <div>
                <h2>{{ 'Message All Drivers' | translate }}</h2>
                <p>{{ 'This notification will be broadcast to every driver subscribed to the driver app topic.' | translate }}</p>
            </div>
        </div>

        <form #messageForm="ngForm" (ngSubmit)="sendToAllDrivers(messageForm)" class="message-form">
            <label>
                <span>{{ 'Notification title' | translate }}</span>
                <input [(ngModel)]="title" [disabled]="isSending" autocomplete="off" maxlength="100"
                       name="title" required>
                <small>{{ title.length }} / 100</small>
            </label>

            <label>
                <span>{{ 'Message' | translate }}</span>
                <textarea [(ngModel)]="message" [disabled]="isSending" maxlength="1000"
                          name="message" required rows="7"></textarea>
                <small>{{ message.length }} / 1000</small>
            </label>

            @if (successMessage !== '') {
                <div class="message-status success" role="status">
                    <i class="material-icons">check_circle</i>
                    <span>{{ successMessage | translate }}</span>
                </div>
            }
            @if (errorMessage !== '') {
                <div class="message-status error" role="alert">
                    <i class="material-icons">error</i>
                    <span>{{ errorMessage | translate }}</span>
                </div>
            }

            <div class="message-actions">
                <button [disabled]="isSending || messageForm.invalid" class="send-message-button" type="submit">
                    <i [class.spinning]="isSending" class="material-icons">
                        {{ isSending ? 'refresh' : 'send' }}
                    </i>
                    <span>{{ (isSending ? 'Sending...' : 'Send to all drivers') | translate }}</span>
                </button>
            </div>
        </form>
            </section>
        }

        @if (canSendCarMessage) {
            <section class="message-panel">
                <div class="message-panel-heading">
                    <i class="material-icons">directions_car</i>
                    <div>
                        <h2>{{ 'Message This Car' | translate }}</h2>
                        <p>{{ 'This notification will be sent only to this car.' | translate }}</p>
                    </div>
                </div>

                <form #carMessageForm="ngForm" (ngSubmit)="sendToCar(carMessageForm)" class="message-form">
                    <label class="message-car-selector">
                        <span>{{ 'Car ID' | translate }}</span>
                        <div class="car-select-wrap">
                            <i class="material-icons car-select-icon">directions_car</i>
                            <input (blur)="closeCarDropdown()"
                                   (focus)="openCarDropdown()"
                                   (keydown.enter)="selectFirstFilteredCar($event)"
                                   (ngModelChange)="onCarSearchChanged($event)"
                                   [attr.aria-expanded]="isCarDropdownOpen"
                                   [attr.aria-label]="'Search and select a car ID' | translate"
                                   [disabled]="isLoadingCars || isSendingToCar"
                                   [ngModel]="carSearchText"
                                   [placeholder]="'Search car ID' | translate"
                                   aria-autocomplete="list"
                                   aria-controls="message-car-options"
                                   autocomplete="off"
                                   name="carSearch"
                                   required
                                   role="combobox"
                                   type="search">
                            <button (click)="toggleCarDropdown()"
                                    (mousedown)="$event.preventDefault()"
                                    [attr.aria-label]="'Toggle Car ID options' | translate"
                                    [disabled]="isLoadingCars || isSendingToCar"
                                    class="car-select-toggle"
                                    type="button">
                                <i class="material-icons">{{ isCarDropdownOpen ? 'expand_less' : 'expand_more' }}</i>
                            </button>
                            @if (isCarDropdownOpen) {
                                <div class="car-options" id="message-car-options" role="listbox">
                                    @for (car of filteredCarOptions; track car.CarIdentifier) {
                                        <button (mousedown)="selectCar(car); $event.preventDefault()"
                                                [attr.aria-selected]="car.CarIdentifier === selectedCarIdentifier"
                                                [class.selected]="car.CarIdentifier === selectedCarIdentifier"
                                                role="option"
                                                type="button">{{ getCarOptionLabel(car) }}
                                        </button>
                                    }
                                    @if (filteredCarOptions.length === 0) {
                                        <span class="no-car-options">{{ 'No matching Car IDs' | translate }}</span>
                                    }
                                </div>
                            }
                        </div>
                    </label>

                    @if (carLoadError !== '') {
                        <div class="message-status error" role="alert">
                            <i class="material-icons">error</i>
                            <span>{{ carLoadError | translate }}</span>
                            <button (click)="loadMessageCars()" [disabled]="isLoadingCars" class="retry-button"
                                    type="button">{{ 'Retry' | translate }}
                            </button>
                        </div>
                    }

                    <label>
                        <span>{{ 'Notification title' | translate }}</span>
                        <input [(ngModel)]="carTitle" [disabled]="isSendingToCar" autocomplete="off" maxlength="100"
                               name="carTitle" required>
                        <small>{{ carTitle.length }} / 100</small>
                    </label>

                    <label>
                        <span>{{ 'Message' | translate }}</span>
                        <textarea [(ngModel)]="carMessage" [disabled]="isSendingToCar" maxlength="1000"
                                  name="carMessage" required rows="7"></textarea>
                        <small>{{ carMessage.length }} / 1000</small>
                    </label>

                    @if (carSuccessMessage !== '') {
                        <div class="message-status success" role="status">
                            <i class="material-icons">check_circle</i>
                            <span>{{ carSuccessMessage | translate }}</span>
                        </div>
                    }
                    @if (carErrorMessage !== '') {
                        <div class="message-status error" role="alert">
                            <i class="material-icons">error</i>
                            <span>{{ carErrorMessage | translate }}</span>
                        </div>
                    }

                    <div class="message-actions">
                        <button [disabled]="isSendingToCar || carMessageForm.invalid || selectedCarIdentifier === ''"
                                class="send-message-button" type="submit">
                            <i [class.spinning]="isSendingToCar" class="material-icons">
                                {{ isSendingToCar ? 'refresh' : 'send' }}
                            </i>
                            <span>{{ (isSendingToCar ? 'Sending...' : 'Send to car') | translate }}</span>
                        </button>
                    </div>
                </form>
            </section>
        }
    </div>
</div>
